import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { DexFormModel, DexInquiry } from '../types';

export function useResetDexFormOnPrefillValuesUpdate({
    form,
    prefillValues,
}: {
    form: UseFormReturn<DexFormModel<DexInquiry>>;
    prefillValues?: DexInquiry;
}) {
    useEffect(() => {
        if (!prefillValues) {
            return;
        }

        const currentForm = form.getValues();

        form.reset({
            ...currentForm,
            params: prefillValues,
        });
    }, [prefillValues, form]);
}
